import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';
import { del, get, set } from 'idb-keyval';

/**
 * IndexedDB-Backend fuer den TanStack-Query-Persister. Werte werden als
 * JSON-Strings unter einem einzelnen Key abgelegt — idb-keyval kuemmert sich
 * um den DB-Lifecycle.
 */
const idbStorage = {
  getItem: async (key: string): Promise<string | null> => {
    const v = await get<string>(key);
    return v ?? null;
  },
  setItem: async (key: string, value: string): Promise<void> => {
    await set(key, value);
  },
  removeItem: async (key: string): Promise<void> => {
    await del(key);
  },
};

export const queryPersister = createAsyncStoragePersister({
  storage: idbStorage,
  key: 'wingseat-query-cache',
  throttleTime: 1000,
});

/**
 * Wird zur Cache-Invalidierung benutzt: wenn sich Schema/Endpunkte aendern,
 * Wert hochzaehlen — dann wirft der Persister den alten Cache weg.
 */
export const CACHE_BUSTER = 'wingseat-v1';
